import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/c100_nav-logo.svg")